import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'telxl-user-data-text',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './user-data-text.component.html',
    styleUrl: './user-data-text.component.scss',
})
export class TelXLUserDataTextComponent {}
